const titles = [
  '',
  'Mr',
  'Mrs',
  'Ms'
]

export default titles
